import { render } from "./ChatHeaderButton.vue?vue&type=template&id=2545d528&scoped=true"
import script from "./ChatHeaderButton.vue?vue&type=script&lang=js"
export * from "./ChatHeaderButton.vue?vue&type=script&lang=js"

import "./ChatHeaderButton.vue?vue&type=style&index=0&id=2545d528&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2545d528"]])

export default __exports__